import {React, useEffect, useState} from 'react'
import {Select,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Skeleton,
  TablePagination,
  TableFooter,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button
} from '@mui/material'
import { useTranslate, useNotify } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import {NotificationFilters} from './logic/NotificationFilters'
import { notificationServices } from 'src/services/sales/notification/notification.service'
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReplyIcon from '@mui/icons-material/Reply';
import EditIcon from '@mui/icons-material/Edit';
import { NotificationForm } from './logic/NotificationForm';
import { parseDateFormat } from 'src/helper/parseDateFormat'
import { HasPermission } from 'src/helper/HasPermission'
import { PERMISSION_SHOW, PERMISSION_REPLY, PERMISSION_EDIT, PERMISSION_DELETE } from 'src/helper/Permission'
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import RefreshIcon from '@mui/icons-material/Refresh';
import { GeneralSearch } from './logic/GeneralSearch';
import LinkIcon from '@mui/icons-material/Link';
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

const ID_ELIMINADO = 15

export const NotificationList = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const [notifications, setNotifications] = useState([])
  const [loadingItems, setLoadingItems] = useState(false)
  const [paginationItemData, setPaginationItemData] = useState({ page: 0, rowsPerPage: 10 })
  const [openDialog, setOpenDialog] = useState(false)
  const [notificationId, setNotificationId] = useState(null)
  const [mode, setMode] = useState('')
  const [reload, setReload] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [notificationToDelete, setNotificationToDelete] = useState(null)
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [openGeneralSearchDialog, setOpenGeneralSearchDialog] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false)
  const [confirmUpdate, setConfirmUpdate] = useState(false)
  const [loadingUpdate, setLoadingUpdate] = useState(false)

  useEffect(()=>{
    if(confirmUpdate){
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[confirmUpdate])

  useEffect(()=>{
    if(confirmDelete){
      onDelete()
    }
  },[confirmDelete])

  const onUpdate = async () =>{
    setLoadingUpdate(true)
    await reservationServices.clear_cache(2).then(()=>{
      setOpenUpdateDialog(false)
      setConfirmUpdate(false)
      notify('ra.notification.updated_notifications_success', {type:'success'})
    }).catch(()=>{
      notify('ra.notification.updated_notifications_error', {type:'error'})
    }).finally(()=>{
      setLoadingUpdate(false)
    })
  }

  const onPageItemChange = (number) => {
    const paginationItemDataAux = { ...paginationItemData }
    paginationItemDataAux.page = number
    setPaginationItemData(paginationItemDataAux)
  }

  const onRowsPerPageItemChange = (e) => {
    const paginationItemDataAux = { ...paginationItemData }
    paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationItemDataAux.page = 0
    setPaginationItemData(paginationItemDataAux)
  }

  const statusStyleBox = (status) =>{
    if(status == 1){
      return {backgroundColor:'rgb(11, 215, 215)'}
    }
    if(status == 2){
      return {backgroundColor:'rgb(237, 158, 39)'}
    }
    if(status == 9){
      return {backgroundColor:'rgb(5, 158, 53)'}
    }
    if(status == 11){
      return {backgroundColor:'rgb(7, 78, 178)'}
    } 
    if(status == 15){
      return {backgroundColor:'rgb(245, 24, 24)'}
    }
    else {
      return {backgroundColor:'rgb(11, 215, 215)'}
    }
  }

  const getNotifications = () =>{
    setLoadingItems(true)
      notificationServices.getAssignedNotification({offset:paginationItemData.page, limit:paginationItemData.rowsPerPage}).then(res=>{
        setNotifications(res.issues)
        setTotalCount(res.total_count)
      }).finally(()=>setLoadingItems(false))
    
    
  }

  useEffect(()=>{
    getNotifications()
  },[reload])

  const onShow = (id) =>{
    setNotificationId(id)
    setMode('show')
    setOpenDialog(true)
  }

  const onNavigateToReserve = (fields) =>{
    if(fields && fields.length > 0){
      const link = fields.find((value)=>value.name === 'Link B2')
      if(link && link.value){
        if(!link.value.includes('---')){
          if(link.value.includes(' - ')){
            const url = link.value.split(' - ')[1];
            window.open(url);
            return
          } else if(!link.value.includes('notification')) {
            const url = link.value;
            window.open(url);
            return
          }
        }
        
      }
    }
    notify('ra.message.notification_redirect_error',{type:'error'})
  }

  const onReply = (id) =>{
    setNotificationId(id)
    setMode('reply')
    setOpenDialog(true)
  }

  const onEdit = (id) =>{
    setNotificationId(id)
    setMode('edit')
    setOpenDialog(true)
  }

  const onDelete = async() =>{
        const auxiliarForm = {
          project_id:notificationToDelete.project?.id,
          assigned_to_id:notificationToDelete.assigned_to?.id,
          watchers:notificationToDelete.watchers,
          subject:notificationToDelete.subject,
          description:notificationToDelete.description,
          notes:notificationToDelete.notes,
          tracker_id:17,
         status_id:ID_ELIMINADO,
          priority_id:3,
          custom_fields:notificationToDelete.custom_fields
        }
        setLoadingDelete(true)
        const formData = new FormData();
        formData.append('payload', JSON.stringify(auxiliarForm));
        await notificationServices.editNotification(formData, notificationToDelete.id).then(res=>{
          setOpenDeleteDialog(false)
          setReload(!reload)
          notify('ra.message.delete_notification_success',{type:'success'})
        }).catch(()=>{
          notify('ra.message.delete_notification_error',{type:'error'})
        }).finally(()=>{
          setLoadingDelete(false)
        })
        
      }
  return (
    <Container className='content'>
      <CardCommon title={translate('ra.field.notification')}>
        <NotificationFilters setPaginationItemData={setPaginationItemData} setTotalCount={setTotalCount} setLoadingItems = {setLoadingItems} setNotifications = {setNotifications} paginationItemData={paginationItemData}/>
        <div style={{display:'flex', flexDirection:'row',justifySelf:'flex-end', marginTop:'15px'}}>
          <HasPermission permission={'search'} resource={'notification'}>
            <Button
              variant='contained'
              sx={{marginRight:'15px'}}
              onClick={()=>{setOpenUpdateDialog(true)}}
            >
              {translate('ra.action.update')}
            </Button>
          </HasPermission>
          <HasPermission permission={'search'} resource={'notification'}>
            <Button
              variant='contained'
              /* sx={{display:'flex'}} */
              onClick={()=>{setOpenGeneralSearchDialog(true)}}
            >
              {translate('ra.action.general_search')}
            </Button>
          </HasPermission>
        </div>
        <RefreshIcon onClick={()=>setReload(!reload)} sx={{display:'flex',justifySelf:'flex-end', marginTop:'15px', cursor:'pointer'}}/>
        <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{translate('ra.field.state')}</TableCell>
                  <TableCell>{'Id'}</TableCell>
                  <TableCell>{translate('ra.field.type')}</TableCell>
                  <TableCell>{translate('ra.field.created_at')}</TableCell>
                  <TableCell>{translate('ra.field.subject')}</TableCell>
                  {/* <TableCell>{translate('ra.field.creation_user')}</TableCell> */}
                  <TableCell>{translate('ra.field.assigned')}</TableCell>
                  <TableCell>{translate('ra.title.actions')}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loadingItems ? (
                  <TableRow>
                    {[...Array(8)].map((_, i) => (
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' width={'100%'} height={20} />
                      </TableCell>
                    ))}
                  </TableRow>
                ) : (
                  notifications?.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Box className='statusBox' style={statusStyleBox(row.status?.id)}>{row.status?.name} </Box>
                      </TableCell>
                      <TableCell>{row?.id}</TableCell>
                      <TableCell>{row?.project?.name}</TableCell>
                      <TableCell>{parseDateFormat(row?.created_on)}</TableCell>
                      <TableCell>
                        {row?.subject}
                      </TableCell>
                      {/* <TableCell>
                        {row?.author?.name}
                      </TableCell> */}
                      <TableCell>
                        {row?.assigned_to?.name}
                      </TableCell>
                      <TableCell>
                        <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-evenly'}}>
                          <HasPermission permission={PERMISSION_SHOW} resource={'notification'}>
                            <VisibilityIcon onClick={()=>onShow(row.id)} style={{cursor:'pointer'}}/>
                          </HasPermission>
                          <HasPermission permission={PERMISSION_REPLY} resource={'notification'}>
                            <ReplyIcon onClick={()=>onReply(row.id)} style={{cursor:'pointer'}}/>
                          </HasPermission>
                          <HasPermission permission={PERMISSION_EDIT} resource={'notification'}>
                            <EditIcon onClick={()=>onEdit(row.id)} style={{cursor:'pointer'}}/>
                          </HasPermission>
                          {row.status.id !== ID_ELIMINADO &&
                          <HasPermission permission={PERMISSION_DELETE} resource={'notification'}>
                            <DeleteIcon onClick={()=>{setNotificationToDelete(row);setOpenDeleteDialog(true)}} style={{cursor:'pointer'}}/>
                          </HasPermission>}
                          <LinkIcon style={{cursor:'pointer'}} onClick={()=>{onNavigateToReserve(row.custom_fields)}}/>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
              <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      count={totalCount}
                      rowsPerPage={paginationItemData.rowsPerPage}
                      page={paginationItemData.page}
                      onPageChange={(e, number) => onPageItemChange(number)}
                      onRowsPerPageChange={(e) => onRowsPerPageItemChange(e)}
                      labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                      }
                    />
                  </TableRow>
                </TableFooter>
            </Table>
          </TableContainer>
        </CardCommon>
        <Dialog open={openDialog}  fullWidth maxWidth='lg' onClose={()=>{setOpenDialog(false)}}>
                <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.field.notification')}
                  <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setOpenDialog(false)}}/>
                </DialogTitle>
                <DialogContent>
                    <NotificationForm reload={reload} setReload = {setReload} setDialogOpen={setOpenDialog} notificationId={notificationId} mode={mode}/>
                </DialogContent>
        </Dialog>
        <Dialog open={openGeneralSearchDialog}  /* fullWidth maxWidth='lg' */ onClose={()=>{setOpenGeneralSearchDialog(false)}}>
            <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.field.notification')}
              <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setOpenGeneralSearchDialog(false)}}/>
            </DialogTitle>
            <DialogContent>
                <GeneralSearch/>
            </DialogContent>
        </Dialog>
        <ConfirmationDialog
            setOpen={setOpenDeleteDialog}
            setConfirm={setConfirmDelete}
            buttonConfirmText={translate('ra.action.acept')}
            buttonCancel={translate('ra.action.cancel')}
            open={openDeleteDialog}
            loadingModalButton={loadingDelete}
            contentText={translate('ra.message.delete_notification_confirm')}
        />

        <ConfirmationDialog
            setOpen={setOpenUpdateDialog}
            setConfirm={setConfirmUpdate}
            buttonConfirmText={translate('ra.action.acept')}
            buttonCancel={translate('ra.action.cancel')}
            open={openUpdateDialog}
            loadingModalButton={loadingUpdate}
            contentText={translate('ra.message.update_confirmation')}
        />
    </Container>
  )
}
